export const Dashboard = ({ color }) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 14 14"
      marginright="8px"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.98412 0.688408C6.16775 -0.229469 7.83225 -0.229469 9.01588 0.688408L12.7492 3.58353C13.5377 4.19501 14 5.13168 14 6.12533V10.7698C14 12.5595 12.5317 14 10.7333 14H3.26667C1.46832 14 0 12.5595 0 10.7698V9.33333C0 9.07559 0.208934 8.86667 0.466667 8.86667C0.7244 8.86667 0.933333 9.07559 0.933333 9.33333V10.7698C0.933333 12.0326 1.97223 13.0667 3.26667 13.0667H10.7333C12.0278 13.0667 13.0667 12.0326 13.0667 10.7698V6.12533C13.0667 5.42292 12.74 4.75746 12.1772 4.32108L8.44391 1.42596C7.59691 0.769125 6.40309 0.769125 5.55609 1.42596L1.82274 4.32108C1.26002 4.75746 0.933333 5.42292 0.933333 6.12533V7C0.933333 7.25774 0.7244 7.46667 0.466667 7.46667C0.208934 7.46667 0 7.25774 0 7V6.12533C0 5.13168 0.462285 4.19501 1.25079 3.58353L4.98412 0.688408Z"
        fill={color}
      />
      <path
        d="M4.43371 9.79932C4.17597 9.79932 3.96704 10.0082 3.96704 10.266C3.96704 10.5237 4.17597 10.7326 4.43371 10.7326H9.56704C9.82478 10.7326 10.0337 10.5237 10.0337 10.266C10.0337 10.0082 9.82478 9.79932 9.56704 9.79932H4.43371Z"
        fill={color}
      />
    </svg>
  );
};

export const Role = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 13 14"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.51105 0.157138C6.15434 -0.0523793 6.84566 -0.0523793 7.48895 0.157138L10.8596 1.25492C12.1395 1.67179 13 2.88815 13 4.24753C13 6.45199 12.3597 8.57682 11.2045 10.3713C11.0478 10.6146 10.7091 10.6418 10.5052 10.4369C10.3449 10.2758 10.3236 10.0229 10.4461 9.8311C11.4912 8.19408 12.0714 6.258 12.0714 4.24753C12.0714 3.28237 11.4605 2.43175 10.5733 2.14282L7.20272 1.04502C6.74549 0.896104 6.25451 0.896104 5.79728 1.04502L2.42666 2.14282C1.53946 2.43175 0.928571 3.28237 0.928571 4.24753C0.928571 7.62869 2.56973 10.7994 5.30316 12.6912C6.02645 13.1918 6.97355 13.1918 7.69684 12.6912C8.16925 12.3643 8.60904 11.9991 9.01339 11.6013C9.20119 11.4165 9.50351 11.4099 9.68936 11.5967C9.86602 11.7743 9.87162 12.0615 9.69377 12.2378C9.24344 12.6844 8.75225 13.094 8.22345 13.4599C7.18306 14.18 5.81694 14.18 4.77655 13.4599C1.78699 11.3909 0 7.93028 0 4.24753C0 2.88815 0.860507 1.67179 2.14043 1.25492L5.51105 0.157138Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10645 4.9C5.10645 4.1268 5.73005 3.5 6.4993 3.5C7.26855 3.5 7.89216 4.1268 7.89216 4.9C7.89216 5.6732 7.26855 6.3 6.4993 6.3C5.73005 6.3 5.10645 5.6732 5.10645 4.9ZM6.4993 4.43333C6.24288 4.43333 6.03502 4.64226 6.03502 4.9C6.03502 5.15774 6.24288 5.36667 6.4993 5.36667C6.75573 5.36667 6.96359 5.15774 6.96359 4.9C6.96359 4.64226 6.75573 4.43333 6.4993 4.43333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71387 9.09896C3.71387 7.8103 4.75322 6.76562 6.0353 6.76562H6.96387C8.24597 6.76562 9.2853 7.8103 9.2853 9.09896C9.2853 9.3567 9.07744 9.56562 8.82101 9.56562H4.17815C3.92173 9.56562 3.71387 9.3567 3.71387 9.09896ZM8.27747 8.63229C8.08625 8.08853 7.57032 7.69896 6.96387 7.69896H6.0353C5.42885 7.69896 4.91291 8.08853 4.72169 8.63229H8.27747Z"
        fill={color}
      />
    </svg>
  );
};

export const Upload = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 14 14"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3 13.3C6.3 13.6866 6.61339 14 7 14C7.38661 14 7.7 13.6866 7.7 13.3V7.7H13.3C13.6866 7.7 14 7.38661 14 7C14 6.61339 13.6866 6.3 13.3 6.3H7.7V0.7C7.7 0.313404 7.38661 0 7 0C6.61339 0 6.3 0.313404 6.3 0.7V6.3H0.7C0.313404 6.3 0 6.61339 0 7C0 7.38661 0.313404 7.7 0.7 7.7H6.3V13.3Z"
        fill={color}
      />
    </svg>
  );
};

export const Pricing = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 18 17"
      marginright="0"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3899 3.74355C12.3341 3.57687 12.2483 3.42752 12.1402 3.29992L13.5971 0.798006C13.726 0.576711 13.6495 0.293737 13.4263 0.165973C13.2031 0.038207 12.9177 0.114028 12.7888 0.335326L11.3319 2.83725C11.1664 2.80822 10.993 2.80924 10.8195 2.84465L7.49064 3.52416C6.60638 3.70466 5.84218 4.25146 5.39076 5.02664L2.62812 9.7708C1.75531 11.2696 2.27328 13.1862 3.78502 14.0515L6.11811 15.387C7.62985 16.2524 9.56291 15.7389 10.4357 14.24L10.562 14.0231C10.6909 13.8018 10.6144 13.5189 10.3912 13.3911C10.168 13.2634 9.88259 13.3392 9.75371 13.5605L9.62741 13.7774C9.01234 14.8336 7.6501 15.1955 6.58479 14.5857L4.25168 13.2501C3.18635 12.6403 2.82134 11.2897 3.43641 10.2335L6.19904 5.48932C6.51716 4.94304 7.05571 4.55772 7.67885 4.43052L10.7717 3.79919L9.58956 5.8293C8.70398 5.56393 7.71888 5.92556 7.23632 6.7542C6.67349 7.72074 7.00749 8.95661 7.98235 9.51464C8.95721 10.0727 10.2037 9.74152 10.7666 8.77498C11.2491 7.94633 11.0724 6.91967 10.3978 6.29198L11.58 4.26187L12.575 7.23318C12.7755 7.83182 12.7082 8.4869 12.3901 9.03319L10.9204 11.557C10.7915 11.7783 10.868 12.0613 11.0912 12.189C11.3144 12.3168 11.5998 12.241 11.7287 12.0197L13.1984 9.49586C13.6497 8.72067 13.7453 7.7911 13.4608 6.9416L12.3899 3.74355ZM9.95827 8.31231C10.2634 7.78837 10.0823 7.11842 9.55386 6.81595C9.02543 6.51345 8.34971 6.69296 8.04461 7.2169C7.73952 7.74081 7.92058 8.41076 8.44901 8.71326C8.97746 9.01574 9.65318 8.83623 9.95827 8.31231Z"
        fill={color}
      />
    </svg>
  );
};

export const EmailIcon = ({ color = "#8f8f8f", className }) => {
  return (
    <svg
      className={className}
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4766 0H1.52344C0.683414 0 0 0.747667 0 1.66667V8.33333C0 9.25233 0.683414 10 1.52344 10H11.4766C12.3166 10 13 9.25233 13 8.33333V1.66667C13 0.747667 12.3166 0 11.4766 0ZM11.2762 1.11111L6.86225 6.02617C6.76741 6.13178 6.63536 6.19236 6.5 6.19236C6.36464 6.19236 6.23261 6.13178 6.13775 6.02617L1.72385 1.11111H11.2762ZM11.9844 8.33333C11.9844 8.63967 11.7566 8.88889 11.4766 8.88889H1.52344C1.24343 8.88889 1.01562 8.63967 1.01562 8.33333V1.90792L5.41328 6.80483C5.69783 7.12172 6.09395 7.30347 6.5 7.30347C6.90605 7.30347 7.30217 7.12172 7.58672 6.80486L11.9844 1.90794V8.33333Z"
        fill="#989898"
      />
    </svg>
  );
};

export const PasswordLock = ({ color = "#8f8f8f", className }) => {
  return (
    <svg
      className={className}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.15625 4.40625H7.31163V2.47898C7.31163 1.11206 6.17611 0 4.78038 0C3.38466 0 2.24913 1.11206 2.24913 2.47898V4.40625H1.40625C0.630844 4.40625 0 5.03709 0 5.8125V10.5938C0 11.3692 0.630844 12 1.40625 12H8.15625C8.93166 12 9.5625 11.3692 9.5625 10.5938V5.8125C9.5625 5.03709 8.93166 4.40625 8.15625 4.40625ZM3.18663 2.47898C3.18663 1.629 3.90159 0.9375 4.78038 0.9375C5.65917 0.9375 6.37413 1.629 6.37413 2.47898V4.40625H3.18663V2.47898ZM8.625 10.5938C8.625 10.8522 8.41472 11.0625 8.15625 11.0625H1.40625C1.14778 11.0625 0.9375 10.8522 0.9375 10.5938V5.8125C0.9375 5.55403 1.14778 5.34375 1.40625 5.34375H8.15625C8.41472 5.34375 8.625 5.55403 8.625 5.8125V10.5938Z"
        fill="#989898"
      />
      <path
        d="M4.78125 6.70312C4.3023 6.70312 3.91406 7.09137 3.91406 7.57031C3.91406 7.87612 4.0725 8.14477 4.31163 8.29917V9.32812C4.31163 9.58699 4.52149 9.79688 4.78038 9.79688C5.03925 9.79688 5.24913 9.58699 5.24913 9.32812V8.30027C5.48923 8.14605 5.64844 7.87688 5.64844 7.57031C5.64844 7.09137 5.2602 6.70312 4.78125 6.70312Z"
        fill="#989898"
      />
    </svg>
  );
};

export const HidePassword = ({
  color = "#8f8f8f",
  className,
  style,
  onClick,
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.77501 6.43322C4.15825 6.33621 3.66985 5.84678 3.57304 5.22882L2.83399 4.48828C2.79489 4.65504 2.77466 4.8276 2.77466 5.00352C2.77466 6.23297 3.77286 7.23321 4.99986 7.23321C5.17505 7.23321 5.34726 7.21285 5.51382 7.17352L4.77501 6.43322Z"
        fill="#989898"
      />
      <path
        d="M9.68834 5.45146C9.74162 5.38179 9.84051 5.23583 9.8516 5.21939L9.99994 4.99996L9.85158 4.78055C9.84047 4.76413 9.74162 4.61821 9.68834 4.54856C9.43951 4.22334 8.85682 3.4617 8.05348 2.79546C7.04748 1.96116 6.02013 1.53812 4.99994 1.53812C4.258 1.53812 3.50818 1.76387 2.76702 2.20938L0.562081 0L0.0100098 0.553185L9.43779 10L9.98989 9.4468L7.88613 7.33882C8.77944 6.63909 9.42604 5.7943 9.68834 5.45146ZM6.25943 5.70885L5.73816 5.18653C5.75314 5.12684 5.76117 5.06437 5.76117 5C5.76117 4.57872 5.42035 4.23721 4.99992 4.23721C4.9357 4.23721 4.87336 4.24528 4.81379 4.26027L4.29253 3.73796C4.50648 3.61725 4.74879 3.55265 4.99992 3.55265C5.79638 3.55265 6.44433 4.20193 6.44433 4.99998C6.44435 5.25215 6.37986 5.49465 6.25943 5.70885ZM6.82533 6.27587C7.08508 5.90424 7.22514 5.46246 7.22514 5C7.22514 3.77055 6.22693 2.77031 4.99994 2.77031C4.53941 2.77031 4.09796 2.91091 3.72679 3.17108L3.33894 2.78244C3.89976 2.47569 4.45681 2.32046 4.99992 2.32046C6.32092 2.32046 7.68346 3.22202 9.04986 5.00002C8.76567 5.37126 8.16014 6.15238 7.32959 6.78119L6.82533 6.27587Z"
        fill="#989898"
      />
      <path
        d="M5.87809 7.54498C5.58249 7.63244 5.28928 7.67661 5.00001 7.67661C3.67903 7.67661 2.31649 6.77505 0.95006 4.99709C1.14617 4.74095 1.53992 4.23266 2.07 3.7292L1.5177 3.17578C0.933849 3.7327 0.511797 4.28405 0.311602 4.54569C0.25834 4.61534 0.159492 4.76124 0.148379 4.77768L0 4.99705L0.14834 5.21648C0.159434 5.23288 0.258301 5.37885 0.311602 5.44855C0.56043 5.77377 1.14315 6.53538 1.94647 7.20163C2.95244 8.03595 3.97981 8.45895 5.00001 8.45895C5.49518 8.45895 5.99383 8.35841 6.49106 8.15917L5.87809 7.54498Z"
        fill="#989898"
      />
    </svg>
  );
};

export const VisiblePassword = ({
  color = "#8f8f8f",
  className,
  style,
  onClick,
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.915 3.27813C10.9038 3.26155 10.8036 3.114 10.7497 3.04356C10.4976 2.71476 9.90728 1.94474 9.09345 1.27116C8.07433 0.427677 7.03358 0 6.00007 0C4.96656 0 3.92581 0.427697 2.9067 1.27118C2.09288 1.94474 1.50258 2.71476 1.25048 3.0436C1.19653 3.11402 1.09639 3.26153 1.08513 3.27813L0.934814 3.49997L1.08509 3.72181C1.09633 3.73839 1.19649 3.88598 1.25048 3.95644C1.50256 4.28524 2.09288 5.05526 2.90668 5.72884C3.92579 6.57232 4.96656 7 6.00007 7C7.03358 7 8.07433 6.5723 9.09345 5.72882C9.9073 5.05524 10.4976 4.28522 10.7497 3.95642C10.8036 3.88598 10.9038 3.73841 10.915 3.72179L11.0653 3.49995L10.915 3.27813ZM6.00007 6.20901C4.66185 6.20901 3.28155 5.29754 1.89727 3.49999C3.28157 1.7024 4.66185 0.790951 6.00007 0.790951C7.3383 0.790951 8.7186 1.70242 10.1028 3.49999C8.71858 5.29756 7.3383 6.20901 6.00007 6.20901Z"
        fill="#989898"
      />
      <path
        d="M6.00019 4.27122C6.4261 4.27122 6.77137 3.92595 6.77137 3.50003C6.77137 3.07412 6.4261 2.72885 6.00019 2.72885C5.57428 2.72885 5.229 3.07412 5.229 3.50003C5.229 3.92595 5.57428 4.27122 6.00019 4.27122Z"
        fill="#989898"
      />
      <path
        d="M6.00008 1.24576C4.7571 1.24576 3.74585 2.25699 3.74585 3.5C3.74585 4.74298 4.75708 5.75423 6.00008 5.75423C7.24309 5.75423 8.25432 4.74298 8.25432 3.5C8.25432 2.25699 7.24307 1.24576 6.00008 1.24576ZM6.00008 4.96326C5.19323 4.96326 4.53682 4.30684 4.53682 3.5C4.53682 2.69316 5.19323 2.03673 6.00008 2.03673C6.80694 2.03673 7.46335 2.69314 7.46335 3.5C7.46335 4.30684 6.80694 4.96326 6.00008 4.96326Z"
        fill="#989898"
      />
    </svg>
  );
};

export const VoiceIcon = ({ color = "#8f8f8f", className, style, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      width="36"
      height="60"
      viewBox="0 0 36 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="Gradient_2_color"
        gradientUnits="userSpaceOnUse"
        x1="5.806"
        x2="18.194"
        y1="18.867"
        y2="6.479"
      >
        <stop offset="0" stopColor="#5433ff" />
        <stop offset="1" stopColor="#20bdff" />
      </linearGradient>
      <path
        d="M18 38.9668C20.9096 38.9635 23.6991 37.7881 25.7566 35.6986C27.814 33.6091 28.9714 30.776 28.9748 27.8209V11.1464C28.9748 8.19022 27.8185 5.35508 25.7603 3.26472C23.7022 1.17435 20.9107 0 18 0C15.0893 0 12.2978 1.17435 10.2396 3.26472C8.18146 5.35508 7.02519 8.19022 7.02519 11.1464V27.8209C7.02859 30.776 8.18598 33.6091 10.2434 35.6986C12.3009 37.7881 15.0904 38.9635 18 38.9668ZM10.347 11.146C10.347 9.08457 11.1533 7.10756 12.5885 5.6499C14.0237 4.19223 15.9703 3.37333 18 3.37333C20.0297 3.37333 21.9763 4.19223 23.4115 5.6499C24.8467 7.10756 25.653 9.08457 25.653 11.146V27.8209C25.653 29.8823 24.8467 31.8593 23.4115 33.317C21.9763 34.7747 20.0297 35.5936 18 35.5936C15.9703 35.5936 14.0237 34.7747 12.5885 33.317C11.1533 31.8593 10.347 29.8823 10.347 27.8209V11.146ZM30.7138 40.9161C27.7558 43.9436 23.8427 45.8168 19.6609 46.207V58.3131C19.6609 58.7605 19.4859 59.1896 19.1744 59.5059C18.8629 59.8223 18.4405 60 18 60C17.5595 60 17.137 59.8223 16.8256 59.5059C16.5141 59.1896 16.3391 58.7605 16.3391 58.3131C16.3391 57.8657 16.3391 46.207 16.3391 46.207C11.8767 45.7741 7.73246 43.6709 4.71247 40.3064C1.69248 36.9419 0.0127353 32.5568 0 28.004C0 27.5566 0.174987 27.1276 0.486466 26.8112C0.797945 26.4949 1.2204 26.3171 1.6609 26.3171C2.1014 26.3171 2.52385 26.4949 2.83533 26.8112C3.14681 27.1276 3.3218 27.5566 3.3218 28.004C3.3218 36.224 9.90622 42.9118 18 42.9118C26.0938 42.9118 32.6782 36.2244 32.6782 28.004C32.6782 27.5566 32.8532 27.1276 33.1646 26.8112C33.4761 26.4949 33.8986 26.3171 34.3391 26.3171C34.7796 26.3171 35.202 26.4949 35.5135 26.8112C35.825 27.1276 36 27.5566 36 28.004C36.0032 30.4044 35.5377 32.7816 34.6303 34.9981C33.7229 37.2145 32.3918 39.2257 30.7138 40.9161Z"
        fill="url(#paint0_linear_488_234)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_488_234"
          x1="10.4325"
          y1="2.21051"
          x2="27.5788"
          y2="56.3166"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.112525" stopColor="#AD58FF" />
          <stop offset="1" stopColor="#5F7DFE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const VoiceAssistance = ({
  color = "#8f8f8f",
  className,
  style,
  onClick,
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      fill={color}
      height="14"
      viewBox="-90 1 511 511.99899"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m332.464844 275.082031c0-8.429687-6.835938-15.265625-15.269532-15.265625-8.433593 0-15.269531 6.835938-15.269531 15.265625 0 74.6875-60.757812 135.445313-135.445312 135.445313-74.683594 0-135.441407-60.757813-135.441407-135.445313 0-8.429687-6.835937-15.265625-15.269531-15.265625-8.433593 0-15.269531 6.835938-15.269531 15.265625 0 86.378907 66.320312 157.539063 150.710938 165.273438v41.105469h-56.664063c-8.433594 0-15.269531 6.835937-15.269531 15.269531 0 8.433593 6.835937 15.269531 15.269531 15.269531h143.871094c8.429687 0 15.265625-6.835938 15.265625-15.269531 0-8.433594-6.835938-15.269531-15.265625-15.269531h-56.667969v-41.105469c84.394531-7.730469 150.714844-78.894531 150.714844-165.273438zm0 0" />
      <path d="m166.480469 372.851562c53.910156 0 97.769531-43.859374 97.769531-97.769531v-177.316406c0-53.90625-43.859375-97.765625-97.769531-97.765625-53.90625 0-97.765625 43.859375-97.765625 97.765625v177.316406c0 53.910157 43.859375 97.769531 97.765625 97.769531zm-67.230469-275.085937c0-37.070313 30.160156-67.226563 67.230469-67.226563 37.070312 0 67.230469 30.15625 67.230469 67.226563v177.316406c0 37.070313-30.160157 67.230469-67.230469 67.230469-37.070313 0-67.230469-30.160156-67.230469-67.230469zm0 0" />
    </svg>
  );
};

export const PauseIcon = ({ color = "#8f8f8f", className, style, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      width="30"
      height="52"
      viewBox="0 0 30 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient id="lg1">
        <stop offset="0" stopColor="#92caff" />
        <stop offset="1" stopColor="#3d59a8" />
      </linearGradient>
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="-14.796"
        x2="77.002"
        href="#lg1"
        y1="17.934"
        y2="110.069"
      />
      <linearGradient
        id="SVGID_00000062161355267158829610000004719995297384627077_"
        gradientUnits="userSpaceOnUse"
        x1="9.274"
        x2="101.072"
        href="#lg1"
        y1="-6.048"
        y2="86.087"
      />
      <linearGradient
        id="SVGID_00000067223142438187105210000012281843523363887549_"
        gradientUnits="userSpaceOnUse"
        x1="19.252"
        x2="111.05"
        href="#lg1"
        y1="-15.99"
        y2="76.145"
      />
      <path
        d="M30 43.2944V8.7056C30 7.56236 29.8553 6.43032 29.5741 5.37411C29.2928 4.3179 28.8807 3.3582 28.3611 2.54981C27.8415 1.74142 27.2246 1.10017 26.5457 0.662674C25.8668 0.225176 25.1391 0 24.4043 0C22.9202 0 21.497 0.917193 20.4476 2.54981C19.3982 4.18242 18.8086 6.39673 18.8086 8.7056V43.2944C18.8086 44.4376 18.9534 45.5697 19.2346 46.6259C19.5158 47.6821 19.928 48.6418 20.4476 49.4502C20.9672 50.2586 21.584 50.8998 22.2629 51.3373C22.9418 51.7748 23.6695 52 24.4043 52C25.1391 52 25.8668 51.7748 26.5457 51.3373C27.2246 50.8998 27.8415 50.2586 28.3611 49.4502C28.8807 48.6418 29.2928 47.6821 29.5741 46.6259C29.8553 45.5697 30 44.4376 30 43.2944ZM11.1914 43.2944V26V8.7056C11.1914 7.56236 11.0466 6.43032 10.7654 5.37411C10.4842 4.3179 10.072 3.3582 9.55243 2.54981C9.03283 1.74142 8.41596 1.10017 7.73706 0.662674C7.05816 0.225176 6.33052 0 5.59569 0C4.11162 0 2.68833 0.917193 1.63894 2.54981C0.589545 4.18242 0 6.39673 0 8.7056V43.2944C0 44.4376 0.144736 45.5697 0.425946 46.6259C0.707155 47.6821 1.11933 48.6418 1.63894 49.4502C2.15855 50.2586 2.77541 50.8998 3.45431 51.3373C4.13321 51.7748 4.86085 52 5.59569 52C6.33052 52 7.05816 51.7748 7.73706 51.3373C8.41596 50.8998 9.03283 50.2586 9.55243 49.4502C10.072 48.6418 10.4842 47.6821 10.7654 46.6259C11.0466 45.5697 11.1914 44.4376 11.1914 43.2944Z"
        fill="url(#paint0_linear_485_199)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_485_199"
          x1="14.5742"
          y1="-6.08865"
          x2="14.5742"
          y2="53.8574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC51FF" />
          <stop offset="1" stopColor="#416FFF" stopOpacity="0.7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LinkIcon = ({ color = "#6B6A6A", className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.44968 5.55067C7.26066 4.36139 5.32575 4.36114 4.13647 5.55067C3.9217 5.76544 3.9217 6.11358 4.13645 6.32836L8.44968 5.55067Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M9.86375 8.44983L9.86374 8.44984C9.26896 9.04436 8.48782 9.34172 7.70714 9.34172C6.92622 9.34172 6.14507 9.04436 5.55054 8.44983C5.33577 8.23506 5.33576 7.88692 5.55051 7.67214L9.86375 8.44983ZM9.86375 8.44983C10.0785 8.23505 10.0785 7.88689 9.86375 7.67212V8.44983ZM6.32827 7.67214C6.11375 7.45734 5.76507 7.45733 5.55054 7.67212L6.32827 7.67214Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M9.08567 8.44959C8.87092 8.23481 8.87092 7.88667 9.08569 7.6719L11.8787 4.87893L9.08567 8.44959ZM9.08567 8.44959C9.19296 8.55714 9.33386 8.61076 9.47455 8.61076C9.61523 8.61076 9.75614 8.55714 9.86342 8.44959L9.8634 8.44962L9.82805 8.41426L9.86345 8.44957L9.08567 8.44959ZM12.6564 4.87893C12.6564 4.87892 12.6564 4.87891 12.6564 4.8789L12.6564 4.87893Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M4.87864 12.6566C4.66388 12.4418 4.66389 12.0936 4.87866 11.8789L6.43989 10.3176L6.43991 10.3176L6.47527 10.353L4.87864 12.6566ZM4.87864 12.6566C4.98592 12.7641 5.12683 12.8177 5.26752 12.8177C5.40821 12.8177 5.54913 12.7641 5.65642 12.6565M4.87864 12.6566L7.21762 10.3176C7.21763 10.3176 7.21764 10.3176 7.21764 10.3176M5.65642 12.6565L5.65637 12.6566L5.62102 12.6212L5.65642 12.6565ZM5.65642 12.6565L7.21762 11.0953C7.43239 10.8806 7.4324 10.5324 7.21764 10.3176M7.21764 10.3176L7.18227 10.353L7.21764 10.3176Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M1.34302 8.34341L1.34302 8.34341L4.13602 5.55066L4.13602 5.55066L1.34302 8.34341ZM1.34302 8.34341C1.12825 8.55818 1.12824 8.90632 1.34299 9.12109M1.34302 8.34341L4.91375 5.55068C5.1285 5.76546 5.12849 6.1136 4.91373 6.32837L4.91372 6.32837L2.12072 9.12112L2.12068 9.12116C2.01324 9.22833 1.8724 9.28226 1.73187 9.28226C1.59119 9.28226 1.45028 9.22864 1.34299 9.12109M1.34299 9.12109C1.343 9.1211 1.34301 9.12111 1.34302 9.12112L1.37837 9.08576L1.34297 9.12107C1.34298 9.12108 1.34299 9.12109 1.34299 9.12109Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M6.78198 3.68284L6.78203 3.68289C6.88951 3.79009 7.03011 3.84374 7.17084 3.84374C7.31133 3.84374 7.4524 3.78983 7.55985 3.68293L7.55994 3.68284L9.12119 2.12134L9.12121 2.12132C9.33595 1.90631 9.33598 1.55817 9.12119 1.34338L9.12117 1.34336C8.90616 1.12863 8.55802 1.12859 8.34323 1.34338L8.34323 1.34338L6.78198 2.90488L6.78196 2.9049C6.56722 3.11991 6.56719 3.46805 6.78198 3.68284Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M1.34324 8.34316C0.173732 9.51269 0.173739 11.4871 1.34326 12.6566M1.34324 8.34316L1.34326 12.6566M1.34324 8.34316C1.55776 8.12836 1.90644 8.12835 2.12097 8.34314C2.12097 8.34314 2.12098 8.34315 2.12098 8.34315L1.34324 8.34316ZM1.34326 12.6566C1.92812 13.2417 2.71443 13.5337 3.49986 13.5337M1.34326 12.6566L3.49986 13.5337M3.49986 13.5337C4.2853 13.5337 5.07161 13.2417 5.65647 12.6563C5.87124 12.4416 5.87124 12.0934 5.65647 11.8786C5.44194 11.6639 5.09328 11.6639 4.87876 11.8786C4.13178 12.6256 2.86794 12.6256 2.12097 11.8786C1.37399 11.1317 1.37399 9.86782 2.12097 9.12085C2.33574 8.90608 2.33574 8.55794 2.12099 8.34316L3.49986 13.5337Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
      <path
        d="M12.6565 5.65684L12.6564 5.65689C12.5489 5.76411 12.4081 5.81774 12.2674 5.81774C12.1267 5.81774 11.9858 5.76413 11.8785 5.65659C11.6637 5.44181 11.6637 5.09366 11.8785 4.87888C12.6255 4.13191 12.6255 2.86806 11.8785 2.12109C11.1316 1.37412 9.86773 1.37412 9.12075 2.12107C9.12074 2.12108 9.12073 2.12108 9.12073 2.12109L9.08537 2.08574C8.89037 2.28099 8.57337 2.28099 8.37837 2.08574L12.6565 5.65684ZM12.6565 5.65684C13.826 4.48731 13.826 2.51291 12.6565 1.34338C11.487 0.173854 9.51254 0.173854 8.34302 1.34338C8.12825 1.55815 8.12824 1.90629 8.34299 2.12107L12.6565 5.65684Z"
        fill="#343541"
        stroke="#343541"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export const RecentIcon = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.88961 1.73333C5.26291 1.73333 3.13356 3.86744 3.13356 6.5H2.40186C2.40186 3.46243 4.8588 1 7.88961 1C10.9204 1 13.3774 3.46243 13.3774 6.5C13.3774 9.53754 10.9204 12 7.88961 12C5.89295 12 4.14575 10.9311 3.18605 9.33477L3.81276 8.9563C4.64558 10.3416 6.15994 11.2667 7.88961 11.2667C10.5163 11.2667 12.6457 9.13259 12.6457 6.5C12.6457 3.86744 10.5163 1.73333 7.88961 1.73333Z"
        fill="#343541"
        fillOpacity="0.6"
      />
      <path
        d="M3.13356 6.55H3.18356V6.5C3.18356 3.89495 5.29063 1.78333 7.88961 1.78333C10.4886 1.78333 12.5957 3.89495 12.5957 6.5C12.5957 9.10508 10.4886 11.2167 7.88961 11.2167C6.17824 11.2167 4.67978 10.3014 3.85562 8.93054L3.8298 8.8876L3.78692 8.9135L3.1602 9.29197L3.11748 9.31777L3.1432 9.36054C4.11154 10.9712 5.87464 12.05 7.88961 12.05C10.9481 12.05 13.4274 9.56505 13.4274 6.5C13.4274 3.43492 10.9481 0.95 7.88961 0.95C4.83108 0.95 2.35186 3.43492 2.35186 6.5V6.55H2.40186H3.13356Z"
        stroke="#343541"
        strokeOpacity="0.6"
        strokeWidth="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1582 7.23338V4.30005H7.8899V6.86672H10.4509V7.60005H7.52405C7.32203 7.60005 7.1582 7.43586 7.1582 7.23338Z"
        fill="#343541"
        fillOpacity="0.6"
      />
      <path
        d="M7.1582 4.25005H7.1082V4.30005V7.23338C7.1082 7.46336 7.29431 7.65005 7.52405 7.65005H10.4509H10.5009V7.60005V6.86672V6.81672H10.4509H7.9399V4.30005V4.25005H7.8899H7.1582Z"
        stroke="#343541"
        strokeOpacity="0.6"
        strokeWidth="0.1"
      />
      <path
        d="M2.88316 5.92216L1.65044 4.06899L1.62269 4.02727L1.58103 4.05511L0.972222 4.46189L0.930734 4.48961L0.958369 4.53115L2.42177 6.73118L2.42177 6.73119C2.54914 6.92262 2.80737 6.97444 2.99852 6.8467C2.99852 6.8467 2.99852 6.8467 2.99852 6.8467L5.19362 5.38004L5.23511 5.35232L5.20747 5.31077L4.8016 4.70062L4.77385 4.65891L4.73219 4.68674L2.88316 5.92216Z"
        fill="#828389"
        stroke="#828389"
        strokeWidth="0.1"
      />
    </svg>
  );
};

export const WidgetIcon = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 30 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.948 1.75C5.04954 1.74997 4.3003 1.74995 3.70552 1.82991C3.07773 1.91432 2.51093 2.09999 2.05546 2.55546C1.59999 3.01093 1.41432 3.57773 1.32991 4.20552C1.24995 4.8003 1.24997 5.54951 1.25 6.44798V8.552C1.24997 9.45047 1.24995 10.1997 1.32991 10.7945C1.41432 11.4223 1.59999 11.9891 2.05546 12.4445C2.51093 12.9 3.07773 13.0857 3.70552 13.1701C4.3003 13.2501 5.04951 13.25 5.94798 13.25H6.052C6.95047 13.25 7.69971 13.2501 8.29448 13.1701C8.92228 13.0857 9.48908 12.9 9.94455 12.4445C10.4 11.9891 10.5857 11.4223 10.6701 10.7945C10.7501 10.1997 10.75 9.4505 10.75 8.55203V6.44801C10.75 5.54954 10.7501 4.8003 10.6701 4.20552C10.5857 3.57773 10.4 3.01093 9.94455 2.55546C9.48908 2.09999 8.92228 1.91432 8.29448 1.82991C7.69971 1.74995 6.9505 1.74997 6.05203 1.75H5.948ZM3.11612 3.61612C3.24644 3.4858 3.44393 3.37858 3.9054 3.31654C4.38843 3.2516 5.03599 3.25 6 3.25C6.96401 3.25 7.61157 3.2516 8.09461 3.31654C8.55607 3.37858 8.75357 3.4858 8.88389 3.61612C9.0142 3.74644 9.12143 3.94393 9.18347 4.4054C9.24841 4.88843 9.25 5.53599 9.25 6.5V8.5C9.25 9.46401 9.24841 10.1116 9.18347 10.5946C9.12143 11.0561 9.0142 11.2536 8.88389 11.3839C8.75357 11.5142 8.55607 11.6214 8.09461 11.6835C7.61157 11.7484 6.96401 11.75 6 11.75C5.03599 11.75 4.38843 11.7484 3.9054 11.6835C3.44393 11.6214 3.24644 11.5142 3.11612 11.3839C2.9858 11.2536 2.87858 11.0561 2.81654 10.5946C2.7516 10.1116 2.75 9.46401 2.75 8.5V6.5C2.75 5.53599 2.7516 4.88843 2.81654 4.4054C2.87858 3.94393 2.9858 3.74644 3.11612 3.61612Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.448 10.75C16.5495 10.75 15.8003 10.7499 15.2055 10.8299C14.5777 10.9143 14.0109 11.1 13.5555 11.5555C13.1 12.0109 12.9143 12.5777 12.8299 13.2055C12.7499 13.8003 12.75 14.5495 12.75 15.448V17.552C12.75 18.4505 12.7499 19.1997 12.8299 19.7945C12.9143 20.4223 13.1 20.9891 13.5555 21.4445C14.0109 21.9 14.5777 22.0857 15.2055 22.1701C15.8003 22.2501 16.5495 22.25 17.4479 22.25H17.552C18.4504 22.25 19.1997 22.2501 19.7945 22.1701C20.4223 22.0857 20.9891 21.9 21.4445 21.4445C21.9 20.9891 22.0857 20.4223 22.1701 19.7945C22.2501 19.1997 22.25 18.4505 22.25 17.5521V15.448C22.25 14.5496 22.2501 13.8003 22.1701 13.2055C22.0857 12.5777 21.9 12.0109 21.4445 11.5555C20.9891 11.1 20.4223 10.9143 19.7945 10.8299C19.1997 10.7499 18.4505 10.75 17.552 10.75H17.448ZM14.6161 12.6161C14.7464 12.4858 14.9439 12.3786 15.4054 12.3165C15.8884 12.2516 16.536 12.25 17.5 12.25C18.464 12.25 19.1116 12.2516 19.5946 12.3165C20.0561 12.3786 20.2536 12.4858 20.3839 12.6161C20.5142 12.7464 20.6214 12.9439 20.6835 13.4054C20.7484 13.8884 20.75 14.536 20.75 15.5V17.5C20.75 18.464 20.7484 19.1116 20.6835 19.5946C20.6214 20.0561 20.5142 20.2536 20.3839 20.3839C20.2536 20.5142 20.0561 20.6214 19.5946 20.6835C19.1116 20.7484 18.464 20.75 17.5 20.75C16.536 20.75 15.8884 20.7484 15.4054 20.6835C14.9439 20.6214 14.7464 20.5142 14.6161 20.3839C14.4858 20.2536 14.3786 20.0561 14.3165 19.5946C14.2516 19.1116 14.25 18.464 14.25 17.5V15.5C14.25 14.536 14.2516 13.8884 14.3165 13.4054C14.3786 12.9439 14.4858 12.7464 14.6161 12.6161Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4748 1.75H18.5253C18.9697 1.75 19.3408 1.74999 19.6454 1.77077C19.9625 1.79241 20.262 1.83905 20.5524 1.95933C21.2262 2.23844 21.7616 2.7738 22.0407 3.44762C22.161 3.73801 22.2076 4.03754 22.2292 4.35464C22.25 4.65925 22.25 5.03029 22.25 5.47475V5.52526C22.25 5.96972 22.25 6.34076 22.2292 6.64537C22.2076 6.96247 22.161 7.26199 22.0407 7.55238C21.7616 8.22621 21.2262 8.76156 20.5524 9.04067C20.262 9.16095 19.9625 9.2076 19.6454 9.22923C19.3408 9.25002 18.9697 9.25001 18.5253 9.25H16.4747C16.0303 9.25001 15.6592 9.25002 15.3546 9.22923C15.0375 9.2076 14.738 9.16095 14.4476 9.04067C13.7738 8.76156 13.2384 8.22621 12.9593 7.55238C12.8391 7.26199 12.7924 6.96247 12.7708 6.64537C12.75 6.34075 12.75 5.96972 12.75 5.52525V5.47475C12.75 5.03029 12.75 4.65925 12.7708 4.35464C12.7924 4.03754 12.8391 3.73801 12.9593 3.44762C13.2384 2.7738 13.7738 2.23844 14.4476 1.95933C14.738 1.83905 15.0375 1.79241 15.3546 1.77077C15.6592 1.74999 16.0303 1.75 16.4748 1.75ZM15.4567 3.26729C15.216 3.28372 15.0988 3.3132 15.0216 3.34515C14.7154 3.47202 14.472 3.71536 14.3452 4.02165C14.3132 4.0988 14.2837 4.21602 14.2673 4.45675C14.2504 4.70421 14.25 5.0238 14.25 5.5C14.25 5.97621 14.2504 6.2958 14.2673 6.54326C14.2837 6.78399 14.3132 6.9012 14.3452 6.97836C14.472 7.28464 14.7154 7.52799 15.0216 7.65485C15.0988 7.68681 15.216 7.71629 15.4567 7.73271C15.7042 7.7496 16.0238 7.75 16.5 7.75H18.5C18.9762 7.75 19.2958 7.7496 19.5433 7.73271C19.784 7.71629 19.9012 7.68681 19.9784 7.65485C20.2846 7.52799 20.528 7.28464 20.6549 6.97836C20.6868 6.9012 20.7163 6.78399 20.7327 6.54326C20.7496 6.2958 20.75 5.97621 20.75 5.5C20.75 5.0238 20.7496 4.70421 20.7327 4.45674C20.7163 4.21602 20.6868 4.0988 20.6549 4.02165C20.528 3.71536 20.2846 3.47202 19.9784 3.34515C19.9012 3.3132 19.784 3.28372 19.5433 3.26729C19.2958 3.25041 18.9762 3.25 18.5 3.25H16.5C16.0238 3.25 15.7042 3.25041 15.4567 3.26729Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97475 14.75C4.53029 14.75 4.15925 14.75 3.85464 14.7708C3.53754 14.7924 3.23801 14.8391 2.94762 14.9593C2.2738 15.2384 1.73844 15.7738 1.45933 16.4476C1.33905 16.738 1.29241 17.0375 1.27077 17.3546C1.24999 17.6592 1.25 18.0302 1.25 18.4747V18.5253C1.25 18.9697 1.24999 19.3408 1.27077 19.6454C1.29241 19.9625 1.33905 20.262 1.45933 20.5524C1.73844 21.2262 2.2738 21.7616 2.94762 22.0407C3.23801 22.161 3.53754 22.2076 3.85464 22.2292C4.15925 22.25 4.53029 22.25 4.97475 22.25H7.02526C7.46972 22.25 7.84076 22.25 8.14537 22.2292C8.46247 22.2076 8.76199 22.161 9.05238 22.0407C9.72621 21.7616 10.2616 21.2262 10.5407 20.5524C10.661 20.262 10.7076 19.9625 10.7292 19.6454C10.75 19.3408 10.75 18.9697 10.75 18.5253V18.4747C10.75 18.0303 10.75 17.6592 10.7292 17.3546C10.7076 17.0375 10.661 16.738 10.5407 16.4476C10.2616 15.7738 9.72621 15.2384 9.05238 14.9593C8.76199 14.8391 8.46247 14.7924 8.14537 14.7708C7.84075 14.75 7.46972 14.75 7.02525 14.75H4.97475ZM3.52165 16.3452C3.5988 16.3132 3.71602 16.2837 3.95675 16.2673C4.20421 16.2504 4.5238 16.25 5 16.25H7C7.47621 16.25 7.7958 16.2504 8.04326 16.2673C8.28399 16.2837 8.4012 16.3132 8.47836 16.3452C8.78464 16.472 9.02799 16.7154 9.15485 17.0216C9.18681 17.0988 9.21629 17.216 9.23271 17.4567C9.2496 17.7042 9.25 18.0238 9.25 18.5C9.25 18.9762 9.2496 19.2958 9.23271 19.5433C9.21629 19.784 9.18681 19.9012 9.15485 19.9784C9.02799 20.2846 8.78464 20.528 8.47836 20.6549C8.4012 20.6868 8.28399 20.7163 8.04326 20.7327C7.7958 20.7496 7.47621 20.75 7 20.75H5C4.5238 20.75 4.20421 20.7496 3.95674 20.7327C3.71602 20.7163 3.5988 20.6868 3.52165 20.6549C3.21536 20.528 2.97202 20.2846 2.84515 19.9784C2.8132 19.9012 2.78372 19.784 2.76729 19.5433C2.75041 19.2958 2.75 18.9762 2.75 18.5C2.75 18.0238 2.75041 17.7042 2.76729 17.4567C2.78372 17.216 2.8132 17.0988 2.84515 17.0216C2.97202 16.7154 3.21536 16.472 3.52165 16.3452Z"
        fill={color}
      />
    </svg>
  );
};

export const ApiKeyIcon = ({ color = "#6B6A6A" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 80"
      fill={color}
      version="1.1"
      style={{ width: "20px", height: "20px", margin: "5px 3px 0 0" }}
      x="0px"
      y="0px"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
    >
      <g>
        <path
          d="M25.189,26.318c0.709,0.488 0.889,1.461 0.401,2.171c-0.488,0.709 -1.46,0.89 -2.17,0.402c-0.71,-0.488 -0.89,-1.461 -0.402,-2.171c0.488,-0.71 1.461,-0.89 2.171,-0.402Z"
          fill={color}
        />
        <path
          d="M27.408,34.199l2.347,1.613c0.128,0.088 0.275,0.145 0.428,0.166l1.742,0.243c-0,0 1.815,1.248 1.815,1.248c0,0 0.851,1.539 0.851,1.539c0.208,0.377 0.634,0.578 1.057,0.5l1.674,-0.31c0,-0 0.89,2.224 0.89,2.224c0.106,0.266 0.322,0.474 0.592,0.57c0.271,0.097 0.569,0.073 0.82,-0.066l5.236,-2.894c0.304,-0.168 0.498,-0.48 0.515,-0.826c0.017,-0.347 -0.146,-0.677 -0.432,-0.873l-7.876,-5.415c-0.455,-0.313 -1.078,-0.197 -1.391,0.257c-0.313,0.455 -0.197,1.078 0.257,1.391l6.544,4.498c-0,0 -2.829,1.563 -2.829,1.563c0,0 -0.773,-1.933 -0.773,-1.933c-0.177,-0.443 -0.642,-0.699 -1.111,-0.612l-1.772,0.328c0,-0 -0.616,-1.115 -0.616,-1.115c-0.075,-0.135 -0.18,-0.252 -0.308,-0.34l-2.205,-1.516c-0.128,-0.088 -0.275,-0.145 -0.428,-0.166l-1.742,-0.243l-1.37,-0.942c0.423,-0.358 0.805,-0.776 1.134,-1.254c0.328,-0.478 0.582,-0.985 0.764,-1.508l2.212,1.521c0.455,0.313 1.078,0.198 1.391,-0.257c0.313,-0.455 0.197,-1.078 -0.257,-1.391l-2.994,-2.058c-0.032,-1.986 -0.992,-3.928 -2.752,-5.138l-0,-0.001c-2.889,-1.985 -6.846,-1.252 -8.832,1.636c-1.985,2.889 -1.252,6.846 1.636,8.832c1.76,1.21 3.917,1.41 5.783,0.729Zm0.28,-9.548c1.979,1.36 2.481,4.071 1.12,6.05c-1.36,1.979 -4.071,2.481 -6.05,1.12c-1.979,-1.36 -2.481,-4.071 -1.12,-6.05c1.36,-1.979 4.071,-2.481 6.05,-1.12l-0,-0Z"
          fill={color}
        />
        <path
          d="M55.171,10l-6.171,0c-0.265,0 -0.52,0.105 -0.707,0.293l-1.697,1.697c-0.391,0.391 -0.391,1.024 -0,1.414c0.39,0.391 1.023,0.391 1.414,0l1.404,-1.404l5.757,0c0.412,1.165 1.524,2 2.829,2c1.656,0 3,-1.344 3,-3c0,-1.656 -1.344,-3 -3,-3c-1.305,0 -2.417,0.835 -2.829,2Zm2.829,0c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Z"
          fill={color}
        />
        <path
          d="M44.792,16.622l0.915,-0.915c0.39,-0.39 0.39,-1.024 0,-1.414c-0.39,-0.39 -1.024,-0.39 -1.414,-0l-1.119,1.118c-0.531,-0.357 -1.084,-0.691 -1.658,-1.002c-6.766,-3.66 -14.716,-3.012 -20.69,1.002l-5.119,-5.118c-0.187,-0.188 -0.442,-0.293 -0.707,-0.293l-6.171,0c-0.412,-1.165 -1.524,-2 -2.829,-2c-1.656,-0 -3,1.344 -3,3c0,1.656 1.344,3 3,3c1.305,-0 2.417,-0.835 2.829,-2l5.757,0l4.622,4.622c-1.907,1.584 -3.548,3.55 -4.799,5.862c-0.27,0.499 -0.516,1.004 -0.74,1.516l-4.669,0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1l3.918,0c-0.518,1.645 -0.813,3.325 -0.895,5l-3.023,0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1l3.025,0c0.088,1.702 0.392,3.383 0.9,5l-3.925,0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1l4.673,0c1.222,2.807 3.092,5.349 5.535,7.378l-4.622,4.622l-5.757,-0c-0.412,-1.165 -1.524,-2 -2.829,-2c-1.656,0 -3,1.344 -3,3c0,1.656 1.344,3 3,3c1.305,0 2.417,-0.835 2.829,-2l6.171,0c0.265,0 0.52,-0.105 0.707,-0.293l5.119,-5.118c0.531,0.357 1.084,0.691 1.658,1.002c0.485,0.263 1.093,0.082 1.355,-0.404c0.263,-0.485 0.082,-1.093 -0.404,-1.355c-8.737,-4.727 -11.994,-15.659 -7.267,-24.397c4.727,-8.737 15.659,-11.994 24.397,-7.267c8.737,4.727 11.994,15.659 7.267,24.397c-3.772,6.971 -11.493,10.453 -18.898,9.176c-0.544,-0.094 -1.062,0.271 -1.155,0.815c-0.094,0.544 0.271,1.062 0.815,1.156c5.102,0.88 10.339,-0.273 14.58,-3.123l5.119,5.118c0.187,0.188 0.442,0.293 0.707,0.293l6.171,0c0.412,1.165 1.524,2 2.829,2c1.656,0 3,-1.344 3,-3c0,-1.656 -1.344,-3 -3,-3c-1.305,0 -2.417,0.835 -2.829,2l-5.757,0l-4.622,-4.622c1.906,-1.583 3.548,-3.55 4.799,-5.862c0.27,-0.499 0.516,-1.004 0.74,-1.516l4.669,0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-3.918,0c0.518,-1.645 0.813,-3.325 0.895,-5l3.023,0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-3.025,0c-0.088,-1.702 -0.392,-3.383 -0.9,-5l3.925,0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-4.673,0c-1.222,-2.807 -3.092,-5.349 -5.535,-7.378Zm13.208,37.378c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1Zm-52,0c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1Zm0,-44c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Z"
          fill={color}
        />
        <circle cx="25.803" cy="49.963" r="1" />
      </g>
    </svg>
  );
};

export const PurpleArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_383_686)">
        <path
          d="M0 10C0 11.9778 0.58649 13.9112 1.6853 15.5557C2.78412 17.2002 4.3459 18.4819 6.17317 19.2388C8.00043 19.9957 10.0111 20.1937 11.9509 19.8079C13.8907 19.422 15.6725 18.4696 17.0711 17.0711C18.4696 15.6725 19.422 13.8907 19.8079 11.9509C20.1937 10.0111 19.9957 8.00043 19.2388 6.17317C18.4819 4.3459 17.2002 2.78412 15.5557 1.6853C13.9112 0.58649 11.9778 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10ZM11.7547 10L7.81733 6.10067C7.64326 5.9266 7.54547 5.69051 7.54547 5.44433C7.54547 5.19816 7.64326 4.96207 7.81733 4.788C7.9914 4.61393 8.22749 4.51614 8.47367 4.51614C8.71984 4.51614 8.95593 4.61393 9.13 4.788L13.7167 9.388C13.8848 9.55662 13.9816 9.78351 13.987 10.0216C13.9923 10.2597 13.9058 10.4907 13.7453 10.6667L9.226 15.2C9.14063 15.2885 9.03851 15.3591 8.92559 15.4077C8.81266 15.4563 8.69119 15.482 8.56825 15.4832C8.44531 15.4844 8.32336 15.4611 8.20951 15.4147C8.09565 15.3683 7.99216 15.2997 7.90507 15.213C7.81798 15.1262 7.74903 15.0229 7.70224 14.9093C7.65544 14.7956 7.63174 14.6737 7.63251 14.5508C7.63328 14.4278 7.6585 14.3063 7.70672 14.1932C7.75493 14.0801 7.82517 13.9777 7.91333 13.892L11.7547 10Z"
          fill="#BB8EF5"
        />
      </g>
      <defs>
        <clipPath id="clip0_383_686">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 -1 1 0 0 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrangeArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_155_3472)">
        <path
          d="M0 10C0 11.9778 0.58649 13.9112 1.6853 15.5557C2.78412 17.2002 4.3459 18.4819 6.17317 19.2388C8.00043 19.9957 10.0111 20.1937 11.9509 19.8079C13.8907 19.422 15.6725 18.4696 17.0711 17.0711C18.4696 15.6725 19.422 13.8907 19.8079 11.9509C20.1937 10.0111 19.9957 8.00043 19.2388 6.17317C18.4819 4.3459 17.2002 2.78412 15.5557 1.6853C13.9112 0.58649 11.9778 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10ZM11.7547 10L7.81733 6.10067C7.64326 5.9266 7.54547 5.69051 7.54547 5.44433C7.54547 5.19816 7.64326 4.96207 7.81733 4.788C7.9914 4.61393 8.22749 4.51614 8.47367 4.51614C8.71984 4.51614 8.95593 4.61393 9.13 4.788L13.7167 9.388C13.8848 9.55662 13.9816 9.78351 13.987 10.0216C13.9923 10.2597 13.9058 10.4907 13.7453 10.6667L9.226 15.2C9.14063 15.2885 9.03851 15.3591 8.92558 15.4077C8.81266 15.4563 8.69119 15.482 8.56825 15.4832C8.44531 15.4844 8.32336 15.4611 8.20951 15.4147C8.09565 15.3683 7.99216 15.2997 7.90507 15.213C7.81798 15.1262 7.74903 15.0229 7.70224 14.9093C7.65544 14.7956 7.63174 14.6737 7.63251 14.5508C7.63328 14.4278 7.6585 14.3063 7.70672 14.1932C7.75493 14.0801 7.82517 13.9777 7.91333 13.892L11.7547 10Z"
          fill="#FEB09A"
        />
      </g>
      <defs>
        <clipPath id="clip0_155_3472">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 -1 1 0 0 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlueArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_155_3474)">
        <path
          d="M0 10C0 11.9778 0.58649 13.9112 1.6853 15.5557C2.78412 17.2002 4.3459 18.4819 6.17317 19.2388C8.00043 19.9957 10.0111 20.1937 11.9509 19.8079C13.8907 19.422 15.6725 18.4696 17.0711 17.0711C18.4696 15.6725 19.422 13.8907 19.8079 11.9509C20.1937 10.0111 19.9957 8.00043 19.2388 6.17317C18.4819 4.3459 17.2002 2.78412 15.5557 1.6853C13.9112 0.58649 11.9778 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10ZM11.7547 10L7.81733 6.10067C7.64326 5.9266 7.54547 5.69051 7.54547 5.44433C7.54547 5.19816 7.64326 4.96207 7.81733 4.788C7.9914 4.61393 8.22749 4.51614 8.47367 4.51614C8.71984 4.51614 8.95593 4.61393 9.13 4.788L13.7167 9.388C13.8848 9.55662 13.9816 9.78351 13.987 10.0216C13.9923 10.2597 13.9058 10.4907 13.7453 10.6667L9.226 15.2C9.14063 15.2885 9.03851 15.3591 8.92558 15.4077C8.81266 15.4563 8.69119 15.482 8.56825 15.4832C8.44531 15.4844 8.32336 15.4611 8.20951 15.4147C8.09565 15.3683 7.99216 15.2997 7.90507 15.213C7.81798 15.1262 7.74903 15.0229 7.70224 14.9093C7.65544 14.7956 7.63174 14.6737 7.63251 14.5508C7.63328 14.4278 7.6585 14.3063 7.70672 14.1932C7.75493 14.0801 7.82517 13.9777 7.91333 13.892L11.7547 10Z"
          fill="#8CA3FC"
        />
      </g>
      <defs>
        <clipPath id="clip0_155_3474">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 -1 1 0 0 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LightBlueArrow = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_181_45)">
        <path
          d="M0 9C0 10.78 0.527841 12.5201 1.51677 14.0001C2.50571 15.4802 3.91131 16.6337 5.55585 17.3149C7.20038 17.9961 9.00998 18.1743 10.7558 17.8271C12.5016 17.4798 14.1053 16.6226 15.364 15.364C16.6226 14.1053 17.4798 12.5016 17.8271 10.7558C18.1743 9.00998 17.9961 7.20038 17.3149 5.55585C16.6337 3.91131 15.4802 2.50571 14.0001 1.51677C12.5201 0.527841 10.78 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9ZM10.5792 9L7.0356 5.4906C6.87894 5.33394 6.79092 5.12146 6.79092 4.8999C6.79092 4.67834 6.87894 4.46586 7.0356 4.3092C7.19226 4.15254 7.40474 4.06452 7.6263 4.06452C7.84786 4.06452 8.06034 4.15254 8.217 4.3092L12.345 8.4492C12.4963 8.60096 12.5835 8.80516 12.5883 9.01944C12.5931 9.23371 12.5152 9.44161 12.3708 9.6L8.3034 13.68C8.22657 13.7596 8.13466 13.8232 8.03303 13.8669C7.93139 13.9107 7.82207 13.9338 7.71143 13.9349C7.60078 13.9359 7.49103 13.915 7.38856 13.8732C7.28609 13.8315 7.19295 13.7698 7.11457 13.6917C7.03619 13.6136 6.97413 13.5206 6.93201 13.4183C6.8899 13.316 6.86857 13.2063 6.86926 13.0957C6.86995 12.985 6.89265 12.8756 6.93605 12.7738C6.97944 12.6721 7.04265 12.5799 7.122 12.5028L10.5792 9Z"
          fill="#20E3D4"
        />
      </g>
      <defs>
        <clipPath id="clip0_181_45">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="matrix(0 -1 1 0 0 18)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DoubleQoute = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={className}
    >
      <path d="M26.0541 6.05531C25.8819 5.78709 25.5844 5.625 25.2658 5.625H18.75C17.1991 5.625 15.9375 6.88659 15.9375 8.4375V15C15.9375 16.5509 17.1991 17.8125 18.75 17.8125H20.6113C19.7407 20.3339 18.9972 21.5414 16.5234 22.5723C16.1106 22.7444 15.877 23.1838 15.965 23.6224C16.0528 24.0601 16.4374 24.375 16.8842 24.375H16.8861C22.0469 24.3658 25.0114 22.2968 27.1134 17.2394C27.7844 15.6509 28.125 13.9508 28.125 12.1875C28.125 9.47569 27.3047 7.99894 26.0541 6.05531Z" />
      <path d="M11.2033 5.625H4.6875C3.13659 5.625 1.875 6.88659 1.875 8.4375V15C1.875 16.5509 3.13659 17.8125 4.6875 17.8125H6.54881C5.67816 20.3339 4.93472 21.5414 2.46094 22.5723C2.04806 22.7444 1.81453 23.1838 1.90247 23.6224C1.99031 24.0601 2.37487 24.375 2.82169 24.375H2.82356C7.98441 24.3658 10.9489 22.2968 13.0509 17.2394C13.7219 15.6509 14.0625 13.9508 14.0625 12.1875C14.0625 9.47569 13.2422 7.99894 11.9916 6.05531C11.8194 5.78709 11.5219 5.625 11.2033 5.625Z" />
    </svg>
  );
};
